<footer class="footer_2 text-center mat-elevation-z8" style="background-color: #0B4595;">
        <div class="row">
            <div class="col-md-12 col-sm-12 col-xs-12 d-flex justify-content-center p-2">
                <div class="rubik_global fw-bold fs-6"> Wediom&copy; {{fecha}}</div>
            </div>
        </div>
</footer>
